import { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(() => typeof navigator !== "undefined" && !navigator.onLine);
  const [justRecovered, setJustRecovered] = useState(false);

  useEffect(() => {
    let recoveryTimer: ReturnType<typeof setTimeout> | undefined;
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => {
      setIsOffline(false);
      setJustRecovered(true);
      clearTimeout(recoveryTimer);
      recoveryTimer = setTimeout(() => setJustRecovered(false), 3500);
    };
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      clearTimeout(recoveryTimer);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  if (!isOffline && !justRecovered) return null;

  return (
    <div
      className="fixed inset-x-3 top-3 z-toast mx-auto flex min-h-11 max-w-lg items-center justify-center gap-2 rounded-xl px-4 py-3 text-center text-sm font-medium shadow-lg"
      style={{
        background: "var(--bg-surface)",
        color: "var(--text-primary)",
      }}
      role="status"
      aria-live="polite"
    >
      {isOffline ? <WifiOff className="h-4 w-4" aria-hidden="true" /> : <Wifi className="h-4 w-4" aria-hidden="true" />}
      {isOffline
        ? "You're offline. You can keep reading loaded material. Reconnect before saving or generating new work."
        : "You're back online. You can retry any unfinished actions."}
    </div>
  );
}
